import {PlaceTypeEnumType} from '@wix/ambassador-seating-v1-seating-reservation/types'
import type {TFunction} from 'react-i18next'

export const getSeatTypeTitle = (type: PlaceTypeEnumType, t: TFunction) => {
  const SEAT_TYPE_TITLE_MAP = {
    [PlaceTypeEnumType.WHEELCHAIR]: () => t('seatings_seatInfo_seatType_wheelchair'),
    [PlaceTypeEnumType.ACCESSIBLE]: () => t('seatings_seatInfo_seatType_accessible'),
    [PlaceTypeEnumType.COMPANION]: () => t('seatings_seatInfo_seatType_companion'),
    [PlaceTypeEnumType.DISCOUNT]: () => t('seatings_seatInfo_seatType_discount'),
    [PlaceTypeEnumType.OBSTRUCTED]: () => t('seatings_seatInfo_seatType_obstructed'),
  }

  return SEAT_TYPE_TITLE_MAP[type]()
}
